import UndoManager from 'undo-manager';

const undoManager = new UndoManager();

export class UndoRedoManager {
    #undoManager;
    constructor(singleton = true) {
        this.#undoManager = singleton ? undoManager : new UndoManager();
    }

    /**
     * Add action to undo stack
     * @param {Function} redoCallback callback to be executed by redo action
     * @param {Array} redoParams list of params to be use by redo function
     * @param {Function} undoCallback callback to be executed by redo action
     * @param {Array} undoParams list of params to be use by undo function
     */
    add(redoCallback, redoParams, undoCallback, undoParams) {
        const params = {
            redo: redoParams,
            undo: undoParams
        };

        this.#undoManager.add({
            redo: function () {
                redoCallback(...params.redo);
            },
            undo: function () {
                undoCallback(...params.undo);
            }
        });
    }

    undo() {
        try {
            this.#undoManager.undo();
        } catch (error) {
            console.error(error);
        }
    }

    redo() {
        try {
            this.#undoManager.redo();
        } catch (error) {
            console.error(error);
        }
    }

    clear() {
        this.#undoManager.clear();
    }

    canUndo() {
        return this.#undoManager.hasUndo();
    }

    canRedo() {
        return this.#undoManager.hasRedo();
    }

    getStackLength() {
        return this.#undoManager.getIndex() + 1;
    }
}
